import React from 'react'

const CreateBrand = function () {
  return (
    <>
      <span>Create Brand</span>
    </>
  )
}

export default CreateBrand
